export default __webpack_public_path__ + "static/media/dino_background_mobile.844f3a35.png";